export const useFormatters = () => {

  const checkValue = (fieldValue) => {
    if (fieldValue !== undefined) {
      return fieldValue;
    }
    return ""
  }

  const getSelectOptions = (options) => {
    let data_list = []
    if (options) {
      Object.keys(options).map(key => {
        data_list.push({
          id: key,
          value: options[key]
        })
      })
    }
    return data_list
  }

  const getKeyvalueObj = (optionList) => {
    const arrayOfObjects = Object.entries(optionList).map(([key, value]) => (
      {
        key: value,
        value,
      }))
    return arrayOfObjects;
  }

  const getDateCalculated = () => {
    // estimated date will be current date + 2 months
    let current_est_date = new Date();
    current_est_date.setMonth(current_est_date.getMonth() + 2);
    const est_order_date = current_est_date.getMonth() + 1;
    const estyear = current_est_date.getFullYear();
    const estdate = current_est_date.getDate();

    // requested date will be current date + 6 months
    let current_req_date = new Date();
    current_req_date.setMonth(current_req_date.getMonth() + 6);
    const req_delivery_date = current_req_date.getMonth() + 1;
    const reqyear = current_req_date.getFullYear();
    const reqdate = current_req_date.getDate();

    const est_order_month = est_order_date < 10 ? '0' + est_order_date : '' + est_order_date;
    const req_delivery_month = req_delivery_date < 10 ? '0' + req_delivery_date : '' + req_delivery_date;

    const finalestdate = estdate < 10 ? '0' + estdate : '' + estdate;
    const finalreqdate = reqdate < 10 ? '0' + reqdate : '' + reqdate;

    const est = `${estyear}-${est_order_month}-${finalestdate}`;
    const req_delivery = `${reqyear}-${req_delivery_month}-${finalreqdate}`;

    return { 'final_est_order_date': est, 'final_req_delivery_date': req_delivery };
  }


  return {
    checkValue,
    getSelectOptions,
    getKeyvalueObj,
    getDateCalculated
  }
}
